module.exports = __webpack_public_path__ + "static/media/water.842287b8.jpg";